import React from 'react';
import Card from 'src/components/common/Card.redesign';
import Project from 'src/models/Project';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IGISProjectCardProps {
    project: Project;
    key?: string;
    onClick?: () => void;
}

const GISProjectCard = (props: IGISProjectCardProps) => {
    const rightBadgePanel = () => {
        if (props.project.updateNeeded === true) {
            return (
                <div style={{ display: 'flex', columnGap: '3rem', alignItems: 'center' }}>
                    <div>{props.project.state?.name}</div>
                    <div style={{ padding: '.4rem', background: 'yellow', fontWeight: 'bold', fontSize: '.8em' }}>Setup Required</div>
                </div>
            );
        }

        return props.project.state?.name || '[State Missing]';
    };

    const infoBarPanel = () => {
        const infoBar = (
            <div>
                <span className="title">{props.project.name}</span> - {countyNames}
            </div>
        );
        return infoBar;
    };

    const countyNames = props.project.counties
        .map((x) => {
            return x.name;
        })
        .toString()
        .replace(/,/g, ', ');
    return (
        <Card
            badge={`${props.project.projectNumber}`}

            rightBadgePanel={rightBadgePanel()}
            infoBar={infoBarPanel()}
            style={{ marginTop: '1rem' }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-around', padding: '1.5rem', marginBottom: '1rem' }}>
                    <div style={{ padding: '.5rem', height: '2rem' }}>
                        <Button text="Select Project" intent="primary" onClick={props.onClick} />
                    </div>
                </div>
        </Card>
    );
};

export default GISProjectCard;



// WEBPACK FOOTER //
// ./src/components/gis/portal/GISProjectCard.tsx